import React, { useEffect } from "react";
import { Hero } from "@/components/Hero";
import { ProHomeBlock } from "@/components/ProHighlight";
import { SocialProof } from "@/components/SocialProof";
import { PackSelection } from "@/components/PackSelection";
import { ProductRange } from "@/components/ProductRange";
import { ComparisonTable } from "@/components/ComparisonTable";
import { HowItWorks } from "@/components/HowItWorks";
import { TargetAudience } from "@/components/TargetAudience";
import { SalesPotential } from "@/components/SalesPotential";
import { WhyOzentya } from "@/components/WhyOzentya";
import { ResultsGallery } from "@/components/ResultsGallery";
import { Testimonials } from "@/components/Testimonials";
import { InstagramFeed } from "@/components/InstagramFeed";
import { ResourcesTeaser } from "@/components/ResourcesTeaser";
import { FormationTeaser } from "@/components/FormationTeaser";
import { HairGuidesTeaser } from "@/components/HairGuidesTeaser";
import { Newsletter } from "@/components/Newsletter";
import { FaqSection, faqs } from "@/components/FaqSection";
import { LegalNotice } from "@/components/LegalNotice";
import { PopupCta } from "@/components/PopupCta";
import { useSeo, useJsonLd, SITE_URL } from "@/lib/seo";

export default function HomePage() {
  useSeo({
    title: "Ozentya — Packs Pro beauté à revendre | Développez votre activité",
    description:
      "Découvrez les 3 Packs Pro Ozentya (10, 15 ou 30 soins cheveux) pour développer une activité de revente à votre rythme. Marque française, actifs naturels, paiement sécurisé et livraison offerte.",
    path: "/packs",
  });

  useJsonLd("ld-organization", {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Ozentya",
    url: SITE_URL,
    logo: `${SITE_URL}/img/packs/hero.jpg`,
    description:
      "Marque française de soins capillaires pour cheveux afro, crépus, bouclés, frisés et texturés, et packs de produits à revendre.",
    sameAs: [
      "https://instagram.com/ozentya_pousse_cheveux",
      "https://www.tiktok.com/@ozentyapoussecheveu",
      "https://www.ozentya.com/",
    ],
  });

  useJsonLd("ld-website", {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Ozentya",
    url: SITE_URL,
    inLanguage: "fr-FR",
  });

  useJsonLd("ld-faq", {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  });

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, []);

  return (
    <>
      <Hero />
      <ProHomeBlock />
      <SocialProof />
      <PackSelection />
      <ProductRange />
      <ComparisonTable />
      <HowItWorks />
      <TargetAudience />
      <SalesPotential />
      <WhyOzentya />
      <ResultsGallery />
      <Testimonials />
      <InstagramFeed />
      <FormationTeaser />
      <HairGuidesTeaser />
      <ResourcesTeaser />
      <FaqSection />
      <LegalNotice />
      <Newsletter />
      <PopupCta />
    </>
  );
}
